var map = {
	"./1 copy.png": "./src/assets/themes/default/ilustrations/1 copy.png",
	"./1.png": "./src/assets/themes/default/ilustrations/1.png",
	"./2 copy.png": "./src/assets/themes/default/ilustrations/2 copy.png",
	"./2.png": "./src/assets/themes/default/ilustrations/2.png",
	"./3.png": "./src/assets/themes/default/ilustrations/3.png",
	"./4.png": "./src/assets/themes/default/ilustrations/4.png",
	"./5.png": "./src/assets/themes/default/ilustrations/5.png",
	"./6.png": "./src/assets/themes/default/ilustrations/6.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/themes/default/ilustrations sync \\.png$";